<template>
<div class="modal inmodal fade" id="add-tariff-modal"  role="dialog">
    <div class="modal-dialog modal-lg">
        <div class="modal-content" >
          <form id="new-tariff-form">

            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" @click="closeModal()" ><span aria-hidden="true">×</span><span class="sr-only">Close</span></button>
                <h3>{{__('add_tariff_type')}}</h3>
            </div>
            <div class="modal-body" id="modalContent">
                    <input type="hidden" name="_token" :value="csrf_token">
                    <div class="form row m-b-sm">
                        <div class="col-md-3 select-parent">
                            <label>{{ __('tariff_type')}}*</label>
                            <select2
                              :settings="{ width: '100%' }"
                              ref="tariff_type_select"
                              :dropdown-parent="select2DropdownParent"
                              name="type"
                              v-model="new_tariff.type"
                              :options="tariff_types"
                              @change="tariffType"
                            />
                            <span class="help-block text-danger" v-for="error in typeErrors">
                              {{error}}
                            </span>
                        </div>
                        <div class="col-md-3">
                            <label>{{ __('contract_or_settlement_period') }}*</label>
                            <select2
                            :settings="{ width: '100%' }"
                            :dropdown-parent="select2DropdownParent"
                              name="billing_period"
                              v-model="new_tariff.billing_period"
                              :options="billingPeriods"
                              :disabled="billing_period_disabled"
                            />
                            <span class="help-block text-danger" v-for="error in billingPeriodErrors">
                              {{error}}
                            </span>
                        </div>

                        <div class="col-md-3">
                            <label>{{ __('max_doc_monthly')}}*</label>
                            <input
                              v-model="new_tariff.max_documents_monthly"
                              type="number"
                              name="max_documents_monthly"
                              class="form-control"
                              min="1"
                              @input="handleMaxDocumentsMonthlyInput"
                              step="1"
                              ref="maxDocumentsInput">
                              <span class="help-block text-danger" v-for="error in maxDocumentsMonthlyErrors">
                                {{error}}
                              </span>
                        </div>

                        <div class="col-md-3">
                            <label>{{ __('max_users')}}*</label>
                            <input
                              v-model="new_tariff.max_users"
                              type="number"
                              name="max_users"
                              class="form-control"
                              min="1"
                              step="1"
                              @input="handleMaxUsersInput"
                              ref="maxUsersInput">
                              <span class="help-block text-danger" v-for="error in maxUsersError">
                                {{error}}
                              </span>
                        </div>
                    </div>
                    <div class="form row">
                        <div class="col-md-12">
                            <label>
                                <input
                                  v-model="new_tariff.many_departments"
                                  name="many_departments"
                                  type="checkbox"
                                  value="1"
                                  :disabled="field_disabled_many_departments"
                                  required/>
                                  {{ __('add_department_possibility')}}
                            </label>
                        </div>
                    </div>
            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-white" data-dismiss="modal" @click="closeModal()">{{ __('cancel')}}</button>
                <button
                  type="button"
                  form="new-tariff-form"
                  class="btn btn-primary"
                  @click="saveTariff()">
                    {{ __('save')}}
                </button>
            </div>
          </form>

        </div>
    </div>
</div>
</template>

<script>
import axios from 'axios';
import {mapActions, mapGetters} from 'vuex'
import {required, minLength, maxLength, minValue, maxValue, integer, helpers, requiredIf} from 'vuelidate/lib/validators'
const greaterThanZero = (value) => value >= 0;
const setMaxValue = (value) => value <= 999999999;

export default {
  data : () => ({
    max_monthly : 1,
    field_disabled_max_users : true,
    field_disabled_many_departments : true,
    billing_period_disabled : false,
    billing_period : {},
    new_tariff : {}
  }),
  validations : {
      new_tariff : {
            type : {
                required
            },
            billing_period : {
                required : requiredIf(function (element){
                  return element.type != 'surcharge';
                })
            },
            max_documents_monthly : {
                required,
                maxValue : setMaxValue
            },
            max_users : {
                required,
                maxValue : setMaxValue
            }
      }
  },

  computed : {

      tariff_types : function () {
        let all_options = [];
        if (!this.isSetFree) {
            let obj = {
                id : 'free',
                text: this.__('free')
              }
            all_options.push(obj);
        }
       let options =  [
          {
            id : 'pre_paid',
            text: this.__('pre_paid')
          },
          {
            id : 'surcharge',
            text: this.__('surcharge')
          },
          {
            id : 'subscription',
            text: this.__('subscription')
          },
        ];
        return all_options.concat(options);
      },
      billingPeriods : function () {

          let options = [
            {
              id: 'month',
              text: this.__('month')
            },
            {
              id: 'quarter',
              text: this.__('quarter')
            },
            {
              id: 'half_year',
              text: this.__('half_year')
            },
            {
              id: 'year',
              text: this.__('year')
            }
          ];
          return options;
      },
      isSetFree : function () {
        if (this.tariffs != null) {
             var filtered = this.tariffs.filter((i,n) => {
                return i.type == 'free';
            });
            return filtered.length > 0 ;
        }
        return false;
      },
      typeErrors : function () {
        const errors = [];
        if (!this.$v.new_tariff.type.$dirty) {
          return errors;
        }
        !this.$v.new_tariff.type.required && errors.push(this.__("field_tariff_type_is_required"));

        return errors;
      },
      billingPeriodErrors : function () {
        const errors = [];
        if (!this.$v.new_tariff.billing_period.$dirty || this.new_tariff.type == 'surcharge') {
          return errors;
        }
        !this.$v.new_tariff.billing_period.required && errors.push(this.__("field_billing_period_is_required"));
        return errors;
      },
      maxDocumentsMonthlyErrors : function () {
        const errors = [];
        if (!this.$v.new_tariff.max_documents_monthly.$dirty) {
          return errors;
        }
        !this.$v.new_tariff.max_documents_monthly.required && errors.push(this.__("field_max_doc_monthly_is_required"));
        !this.$v.new_tariff.max_documents_monthly.maxValue && errors.push(this.__("given_value_is_to_big"));
        return errors;
      },
      maxUsersError : function () {
        const errors = [];
        if (!this.$v.new_tariff.max_users.$dirty) {
          return errors;
        }
        !this.$v.new_tariff.max_users.required && errors.push(this.__("field_max_users_is_required"));
        !this.$v.new_tariff.max_users.maxValue && errors.push(this.__("given_value_is_to_big"));
        return errors;
      },
      select2DropdownParent: function () {
          return $('#modalContent');
      },
  },
  props : [
    'route_tariff_store',
    'csrf_token',
    'tariffs',
    'services',
    'service_template_details',
  ],
  methods: {
      ...mapActions(['addTariffType']),
      checkForm : function (e) {
          this.$v.new_tariff.$touch();
          return !this.$v.new_tariff.$error;
      },
      handleMaxDocumentsMonthlyInput() {
          // Usunięcie niepożądanych znaków (wszystko oprócz cyfr)
          this.new_tariff.max_documents_monthly = this.new_tariff.max_documents_monthly.replace(/\D/g, '');

          const value = parseInt(this.new_tariff.max_documents_monthly);
          if (isNaN(value) || value < 0) {
              this.new_tariff.max_documents_monthly = '0'; // Ustawienie na 1, jeśli wprowadzono błędną wartość
          }
      },
      handleMaxUsersInput() {
          // Usunięcie niepożądanych znaków (wszystko oprócz cyfr)
          this.new_tariff.max_users = this.new_tariff.max_users.replace(/\D/g, '');

          const value = parseInt(this.new_tariff.max_users);
          if (isNaN(value) || value < 0) {
              this.new_tariff.max_users = '0'; // Ustawienie na 1, jeśli wprowadzono błędną wartość
          }
      },

      closeModal() {
          this.new_tariff = new Object();
          this.new_tariff = {
            type : '',
            billing_period : '',
            max_documents_monthly : '',
            max_users : '',
            many_departments : ''}
            this.$v.$reset();
          $('#add-tariff-modal').modal('hide');
      },
      tariffType : function(e) {
        switch (e) {
          case 'free':
              this.billing_period_disabled = false;
              this.field_disabled_max_users = true;
              this.field_disabled_many_departments = false;
            break;
          case 'pre_paid' :
              this.billing_period_disabled = false;
              this.field_disabled_max_users = true;
              this.field_disabled_many_departments = false;
            break;
          case 'surcharge':
              this.field_disabled_many_departments = true;
              this.field_disabled_max_users= false;
              this.billing_period_disabled = true;
              this.billing_period = null;
              this.new_tariff.billing_period = null;
              this.new_tariff.many_departments = ''
            break;
          case 'subscription':
              this.max_monthly = '';
              this.billing_period_disabled = false;
              this.field_disabled_max_users = false;
              this.field_disabled_many_departments = false;
            break;
          default:

        }
      },
      createDetails : function() {
          let tariff_details = new Object();
          for (const [detail_key, detail_value] of Object.entries(this.service_template_details)) {
              if(detail_value['fee_base'] == 'tariff'){
                  tariff_details[detail_value['id']] = '';
              }

          }
          return tariff_details;
      },
      saveTariff : function() {
          if (this.checkForm()) {
              this.new_tariff['tariffs_details'] = this.createDetails();
              this.addTariffType(this.new_tariff);
              this.closeModal();
          }
      },

      setTariffName : function(new_tariff) {
          let filtered = [];
          if (this.tariffs != undefined) {
              filtered = this.tariffs.filter((item) => {
                  return new_tariff.type == item.type;
              });
          }
          let prefix = '';
          switch (new_tariff.type) {
            case  'free':
              prefix = 'F';
              return prefix;
              break;
            case  'pre_paid':
              prefix = 'P';
              break;
            case  'surcharge':
              prefix = 'X';
              break;
            case  'subscription':
              prefix = 'A';
              break;
            default:
          }
          let number = filtered.length < 9 ? '0'.concat(parseInt(filtered.length) + 1)  : parseInt(filtered.length) + 1;

          return prefix.concat(number);


      }
  },
  mounted : function () {
      this.new_tariff = new Object();
      this.new_tariff = {
        name: '',
        type : '',
        billing_period : '',
        max_users : '',
        max_documents_monthly : '',
        many_departments : ''}
      this.$refs.maxDocumentsInput.addEventListener('keypress', function (event) {
          if (event.key === '.' || event.key === '-') {
              event.preventDefault();
          }
      });
      this.$refs.maxUsersInput.addEventListener('keypress', function (event) {
          if (event.key === '.' || event.key === '-') {
              event.preventDefault();
          }
      });
  }
}
</script>

<style lang="css" scoped>
.select2 {
  width:100%!important;
}
.select2-container--default .select2-selection--single {
    border: 1px solid #c9ccd0 !important;
    border-radius: 0px !important;
	height: 30px !important;
}
.select2-container--default.select2-container--focus .select2-selection--single, .select2-container--default.select2-container--open.select2-container--below .select2-selection--single {
	border-color: #495966!important;
}
.select2-results__option {
    font-size: 11px !important;
}
.select2-container--default .select2-results__option--highlighted[aria-selected] {
    background-color: #1ab394;
}
.select2-container--open {
  z-index:9999!important;
}
.select2-search__field {
  display: none;
}
.select-parent .select2-container {
    z-index: 9999 !important;
}
</style>
